import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "title uppercase" }, "How we got here", -1)
const _hoisted_2 = { class: "subtitle" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" The Story of ")
const _hoisted_4 = { class: "space-y-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Increasingly seeing people with college gear from Harvard or Yale makes one wonder if those people are students of those universities, supposedly they are not, why would they wear those clothes? ", -1)
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" With this increase of college-themed logomania in urban fashion, questions of conformity and unification arose, and ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" investigates this crossover by colliding college-themed and urban fashion garments to a level where a golden pinned balaclava is worn with a logomania college varsity jacket. ")
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Moreover, ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" showcases those five character avatars as the heroes of their own told story that is captured by a portrait photo look. With that approach, ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" portrays a story of a subcultural world of conformity, unification, and the romanticization of educational institutions in fashion, media, and youth culture. ")
const _hoisted_13 = { class: "flex items-center justify-center" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Explore")

import DripversityIcon from "@/components/icons/DripversityIcon.vue";
import AppButton from "@/components/app/AppButton.vue";
import TextCenteredSection from "@/components/section/TextCenteredSection.vue";
import { routes } from "@/constants";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeStory',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TextCenteredSection, { id: "story" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("h3", _hoisted_2, [
        _hoisted_3,
        _createVNode(DripversityIcon, { class: "text-dripversity w-16 mb-0.5" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, [
          _hoisted_7,
          _createVNode(DripversityIcon, { class: "text-dripversity" }),
          _hoisted_8
        ]),
        _createElementVNode("p", _hoisted_9, [
          _hoisted_10,
          _createVNode(DripversityIcon, { class: "text-dripversity" }),
          _hoisted_11,
          _createVNode(DripversityIcon, { class: "text-dripversity" }),
          _hoisted_12
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(AppButton, {
          color: "secondary",
          to: _unref(routes).home.Rarity
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _: 1
  }))
}
}

})